import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { BILLINGPOC } from "./type";


export const clientBillingAddress = (clientId, gst_address = null) => async (dispatch) => {
  const url = gst_address ? `${Config.client.fetchBillingAddress}${clientId}&gst_address=${gst_address}` : `${Config.client.fetchBillingAddress}${clientId}`;
  const res = await callWebService(
    callTypes.get,
    "",
    url
  );
  if (res) {
    const payload = res.data?.response?.data ?? res.data?.data;
    dispatch({ type: BILLINGPOC, payload });
    return true;
  }
};

